import { createAsyncThunk } from "@reduxjs/toolkit";
import SupplierPackagesApiService from "../../infrastructure/api/supplierPackages";
import { setMessage } from "../slices/message";

// Get Supplier Packages List
export const fetchSupplierPackages = createAsyncThunk(
  "supplierPackages/fetchList",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await SupplierPackagesApiService.getSupplierPackages(
        params
      );
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت لیست پکیج‌ها";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Get Package Details for Edit
export const fetchSupplierPackageDetails = createAsyncThunk(
  "supplierPackages/fetchDetails",
  async (packageId, { dispatch, rejectWithValue }) => {
    try {
      const response = await SupplierPackagesApiService.getPackageById(
        packageId
      );
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت جزئیات پکیج";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Create Package
export const createSupplierPackage = createAsyncThunk(
  "supplierPackages/create",
  async (packageData, { dispatch, rejectWithValue }) => {
    try {
      const response = await SupplierPackagesApiService.modifyPackage({
        ...packageData,
        packageId: 0,
      });
      if (response.isSuccess) {
        dispatch(setMessage({ text: response.message, type: "success" }));
      }
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "خطا در ایجاد پکیج";
      dispatch(setMessage({ text: message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);

// Update Package
export const updateSupplierPackage = createAsyncThunk(
  "supplierPackages/update",
  async ({ id, packageData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await SupplierPackagesApiService.modifyPackage({
        ...packageData,
        packageId: id,
      });
      if (response.isSuccess) {
        dispatch(setMessage({ text: response.message, type: "success" }));
      }
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "خطا در ویرایش پکیج";
      dispatch(setMessage({ text: message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);

// Delete Package
export const deleteSupplierPackage = createAsyncThunk(
  "supplierPackages/delete",
  async (packageId, { dispatch, rejectWithValue }) => {
    try {
      const response = await SupplierPackagesApiService.deletePackage(
        packageId
      );
      if (response.isSuccess) {
        dispatch(setMessage({ text: response.message, type: "success" }));
      }
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "خطا در حذف پکیج";
      dispatch(setMessage({ text: message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);
